export const constructDateWithTimeZone = (date: string, timezone: string) => {
  return new Date(
    // TODO: i18n ... this crashes if it's not 'en'...
    new Date(date).toLocaleString('en', {
      timeZone: timezone,
    }),
  )
}
